<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.14 32.3">
    <g>
      <!-- Inherit dynamic fill -->
      <path
        d="M25,0V17.57L3.17.06V0H0V21.69H3.17V4.14l21.77,17.5h0v0h3.19V0Z"
        :fill="iconColor"
      />
      <!-- Always green fill -->
      <path
        d="M7.26,32.3H20.49c.23,0,.35-.18.21-.3l-6.62-5.37a.4.4,0,0,0-.42,0L7,32c-.14.12,0,.3.21.3"
        fill="#a5d867"
      />
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'
  export default {
    name: 'LogoIcon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#383935'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 28px;
    height: 32px;
  }
</style>
